import { Injectable } from '@angular/core';
import * as Sentry from "@sentry/angular";
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ErrorReporterService {
  reportError(error: Error): void {
    if (!environment.logToSentry) return;
    Sentry.captureException(error);
  }
}
